module.exports = __webpack_public_path__ + "src/assets/img/share/tips/pleasant/4380728c6c85f5c9dbab81b54733149d.png";